import { useGetDashboardSummary } from "@/api";
import { useSessionStore } from "@/stores/session.store";

export function useDashboardStats() {
  const activeStoreId = useSessionStore((state) => state.activeStoreId);
  const enabled = activeStoreId !== null;

  const { data: summaryData, isLoading } = useGetDashboardSummary(
    activeStoreId !== null ? { store_id: activeStoreId } : undefined,
    { query: { enabled } },
  );

  const summary = summaryData?.data?.data;

  return {
    isLoading,
    stats: {
      todaySales: summary?.today_sales_amount ?? 0,
      awaitingPayment: summary?.pending_payment_orders_count ?? 0,
      preparing: summary?.preparing_orders_count ?? 0,
      todayOrdersCount: summary?.today_orders_count ?? 0,
    },
  };
}
